module.exports = __webpack_public_path__ + "img/student.271afdec.svg";